// loading.jsx
import React, { useState, useEffect } from 'react';

const Loading = (api_call) => {
    const divLoadingStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: '#dadada',
        fontFamily: 'Arial',
        // backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '10px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        padding: '20px',
    };

    const [loadingText, setLoadingText] = useState('loading.');

    useEffect(() => {
        const texts = ['loading.', 'loading..', 'loading...'];
        let index = 0;
        const interval = setInterval(() => {
            setLoadingText(texts[index]);
            index = (index + 1) % texts.length;
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={divLoadingStyle}>
            {/* <h1>{loadingText}</h1> */}
            <h1 style={{ color: "black" }}>{loadingText}</h1>
        </div>
    );
};

export default Loading;